import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm, Table } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeDataVersion, updateSts } from './dataVersionSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { isUserAdmin } from '../../services/authenticationService';

export default function DataVersionPageList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const DataVersion = useSelector(
    (state: AppState) => state.DataVersions
  );

  useEffect(() => {
    if (DataVersion.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: DataVersion.success.data,
      });

      dispatch(updateSts({}));
    } else if (DataVersion.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: DataVersion.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [DataVersion])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeDataVersion(id));
    /*  messageApi.open({
       type: 'success',
       content: 'Data Version deleted successfully',
     }); */
  };

  const columns = [
    {
      title: 'Version',
      dataIndex: 'version_no',
      key: 'version_no',
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
    },
    {
      title: 'Created by',
      dataIndex: ['user', 'user_name'],
      key: 'user_name',
    },
  ];
  const versionHistory = DataVersion.DataVersion.slice(1); // Exclude the first record

  return (
    <>

      <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        dataSource={DataVersion.DataVersion.slice(0, 1)} // Include only the first record
        renderItem={(item: any, index) => (
          <List.Item key={item.id}
            actions={isUserAdmin() && index === 0 ?
              [
                <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
                  <DeleteOutlined style={{ color: 'red' }} />
                </Popconfirm>] : []}>

            <div className='main_class'>
              <p className='sub_data'>
                <b>Version:</b> {item.version_no} <br />
                <b>Remarks:</b> {item.remarks} <br />
                <b>Created by:</b> {item.user?.user_name}
              </p>
            </div>
          </List.Item>

        )}
      />
      {versionHistory.length > 0 ? (
        <>
          <h4>Version History</h4>
          <Table dataSource={versionHistory} columns={columns} rowKey="id" />
        </>
      ) : null}
    </>
  );
}